import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class CalcProgramReleaseApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'calcProgramRelease';
    }

    /**
     * 获取数据
     * @param programId 
     * @returns 
     */
    public getLastProgramReleases(programId: number) {
        return this.send({ programId }, "getLastProgramReleases", Methods.GET);
    }
}